<template>

  <TemplateMain>
    <slot slot="breadcrumb" name="breadcrumb"/>

    <ol slot="breadcrumb" class="breadcrumb">
      <li class="breadcrumb-item" 
        v-for="breadcrumbItem of breadcrumb"
        v-bind:key="breadcrumbItem.name">
        <a v-bind="breadcrumbItem.url ? { href:breadcrumbItem.url } : {}">
          {{ getBreadcrumb(breadcrumbItem) }}
        </a>
      </li>
    </ol>

    <div v-show="disable_page || !hasViewPermission()">
      You don't have permission to access this page.
    </div>

    <!-- <slot slot="breadcrumb" name="breadcrumb"/> -->
    <div v-show="!disable_page && hasViewPermission()">

      <TemplateCard v-if="card">
        <slot />
      </TemplateCard>
      <slot v-else />

    </div>

  </TemplateMain>

</template>

<script>
import TemplateMain from "@/components/Template/TemplateMain";
import TemplateCard from "@/components/Template/TemplateCard";
import helper from "@/components/Utility/Helper"

export default {
  name: "TemplateBasic",
  props: {
    'breadcrumb': null,
    'permission': null,
    'disable_page': false,
    'card': {
      default: true
    },
  },
  data () {
    return {

    }
  },
  components: {
    TemplateMain,
    TemplateCard
  },
  methods: {
    hasViewPermission() {
      return helper.hasViewPermission(this.permission);
    },
    getBreadcrumb(breadcrumbItem) {
      if(breadcrumbItem.name === 'Home') {
        if(window.location.href.includes('localhost')) {
          document.title = 'Localhost';
          return 'Localhost';
        } else if(window.location.href.includes('parkbills.parkaidemobile.com')) {
          document.title = 'ParkBills Dev';
          return 'ParkBills Dev';
        } else if(window.location.href.includes('devpbills.parkaidemobile.com')) {
          document.title = 'ParkBills Dev';
          return 'ParkBills Dev';
        } else {
          return breadcrumbItem.name;
        }
      } else {
        return breadcrumbItem.name;
      }
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Template/TemplateBasic.vue